import { h } from "hyperapp";

import emptyStateCSS from "./empty-state.css";

export const emptyState = ({ translations, state: { show } }) => {
  return (
    show && (
      <div className={emptyStateCSS.emptyStateContainer}>
        <div className="col-md-8 ">
          <h4>{translations["emptyStateTitle"]}</h4>
          <p>
            {translations["emptyStateDescription1"]}
            {translations["emptyStateDescription1-2"]}
          </p>
          <p>{translations["emptyStateDescription2"]}</p>
          <p>{translations["emptyStateDescription3"]}</p>
          <p>
            {translations["emptyStateDescription4"]}
            <a href={translations["emptyStateHelperLink"]} target="_blank">
              &nbsp;{translations["emptyStateHelperText"]}
            </a>
          </p>
        </div>
      </div>
    )
  );
};
